import assert from '@/sui/tools/assert'

function createRep () {
  return {
    type: 'rep',
    total: 0,
    values: {},

    increment: function (field) {
      this.incrementN(field, 1)
    },

    incrementN: function (field, value) {
      this.total += value
      if (this.values[field] == null) {
        this.values[field] = value
      } else {
        this.values[field] += value
      }
    }
  }
}

function createRepH () {
  const result = createRep()
  result.hidep = true
  return result
}

const initialize = {
  rep: createRep,
  reph: createRepH
}

function extractDistribution (list, tests) {
  const result = {}
  for (let i = 0; i !== list.length; ++i) {
    const l = list[i]
    for (let j = 0; j !== tests.length; ++j) {
      const t = tests[j]

      if (i === 0) {
        const type = initialize[t.type]
        assert.notNull(type, `Unknown type : ${t.type}`)
        const b = type()
        if (t.initialize != null) {
          t.initialize(b)
        }
        result[t.key] = b
      }
      t.apply(result[t.key], l)
    }
  }
  return result
}

export default {
  extract: extractDistribution,
  createRep: createRep
}
